module.exports = "<div class=\"sold-out-container\">\r\n  <div class=\"sold-out\">\r\n    ELADVA\r\n  </div>\r\n\r\n</div>\r\n"